import styled from 'styled-components';

import { COLORS } from '@theme/colors';

export const Container = styled.div`
  position: relative;
  background-color: ${COLORS.GALLERY};
  display: flex;
  flex-direction: row;
  padding: 0 12px;
  align-items: center;
`;

export const Input = styled.input`
  border: none;
  width: 100%;
  outline: none;
  background-color: transparent;
  padding: 0;

  &[type='number']::-webkit-outer-spin-button,
  &[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type='number'] {
    -moz-appearance: textfield;
  }
`;

export const Label = styled.label`
  letter-spacing: 0.01px;
  white-space: nowrap;
  margin-right: 10px;
`;

export const AdditionalInformation = styled.div`
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: ${COLORS.SILVER_CHALICE};
  letter-spacing: 0.01px;
`;
